import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="input-range"
export default class extends Controller {
  static targets = ['value']

  update(e) {
    this.valueTarget.textContent = e.target.value
  }
}
